import { AtestadoMedico } from "../../../interfaces/entities/AtestadoMedico";
import { FilterInterface } from "../../../interfaces/entities/FilterInterface";
import { OrderingAtestadosEnum } from "../../../interfaces/enum/OrderingAtestadosEnum";

export const orderingOptionsDefault: FilterInterface[] = [
    {
      id: OrderingAtestadosEnum.MaisAntigo,
      descricao: OrderingAtestadosEnum.MaisAntigo
    },
    {
      id: OrderingAtestadosEnum.MaisRecente,
      descricao: OrderingAtestadosEnum.MaisRecente
    },
]

export const typesOfAppointmentDefault: FilterInterface[] = [
    {id: 'P', descricao: 'Presencial'  },
    {id: 'T',descricao: 'Teleatendimento'}
]

export const defaultAtestado: AtestadoMedico = {
    idAtestado: '',
    nomeMedico: '',
    espec: '',
    tipo: '',
    unidade: '',
    dtConsulta: ''

}